module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('plex-header'), _vm._v(" "), (_vm.typeList.length > 0) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row content-box"
  }, [_c('div', {
    staticClass: "col-md-2",
    attrs: {
      "id": "pc-type-list"
    }
  }, [_c('ul', _vm._l((_vm.typeList), function(type, index) {
    return _c('li', {
      class: [{
        'active-type': _vm.currentType === type.id
      }],
      on: {
        "click": function($event) {
          return _vm.updateFaqs(type.id)
        }
      }
    }, [_vm._v(_vm._s(type.name))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "right-border"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    attrs: {
      "id": "phone-type-list"
    }
  }, [_c('div', {
    staticClass: "type-list-box"
  }, [_c('ul', _vm._l((_vm.typeList), function(type) {
    return _c('li', {
      class: [{
        'active-type': _vm.currentType === type.id
      }],
      on: {
        "click": function($event) {
          return _vm.updateFaqs(type.id)
        }
      }
    }, [_vm._v(_vm._s(type.name))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "bottom-border"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-10 col-sm-12 col-xs-12",
    attrs: {
      "id": "faq-lists"
    }
  }, [_c('spinner', {
    staticClass: "spinner-component",
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _vm._l((_vm.faqList), function(faq, index) {
    return (!!faq.question && !!faq.answer) ? [_c('a', {
      attrs: {
        "href": "",
        "id": 'faq' + faq.id
      }
    }), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.loading),
        expression: "!loading"
      }],
      staticClass: "question-box"
    }, [_c('span', {
      staticClass: "main-index"
    }, [_vm._v("Q:")]), _c('div', {
      staticClass: "question",
      domProps: {
        "innerHTML": _vm._s(faq.question)
      }
    })]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.loading),
        expression: "!loading"
      }],
      staticClass: "answer-box"
    }, [_c('span', {
      staticClass: "main-index"
    }, [_vm._v("A:")]), _c('div', {
      staticClass: "answer",
      domProps: {
        "innerHTML": _vm._s(faq.answer)
      }
    })])] : _vm._e()
  })], 2)])]) : _vm._e(), _vm._v(" "), _c('plex-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-747c7577!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/faq/FAQ.vue
// module id = 1356
// module chunks = 1